import httpClient from "http-client/http-client";

const COMMUNITY_PORTAL_BASE = "v1/community-portal/community";

export async function listPortalCommunities({ current_page = 1, page_size = 10, ...rest } = {}) {
  const { data, errors } = await httpClient.post({
    url: `${COMMUNITY_PORTAL_BASE}/list`,
    body: { current_page, page_size, ...rest },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function createPortalCommunity(body) {
  const { data, errors } = await httpClient.post({
    url: `${COMMUNITY_PORTAL_BASE}/`,
    body,
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function getPortalCommunity(communityId, params = {}) {
  const { data, errors } = await httpClient.get({
    url: `${COMMUNITY_PORTAL_BASE}/${encodeURIComponent(communityId)}`,
    params,
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function getPortalCommunityStatistics(communityId) {
  const { data, errors } = await httpClient.get({
    url: `${COMMUNITY_PORTAL_BASE}/${encodeURIComponent(communityId)}/statistics`,
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function updatePortalCommunity(communityId, body) {
  const { data, errors } = await httpClient.put({
    url: `${COMMUNITY_PORTAL_BASE}/${encodeURIComponent(communityId)}`,
    body,
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export const getCommunity = getPortalCommunity;
export const updateCommunity = updatePortalCommunity;

export async function getPortalCommunityMembers(communityId, params = {}) {
  const { data, errors } = await httpClient.post({
    url: `${COMMUNITY_PORTAL_BASE}/${encodeURIComponent(communityId)}/members/fetch`,
    body: {
      current_page: params.current_page ?? 1,
      page_size: params.page_size ?? 10,
      ...(params.membership_status && {
        membership_status: params.membership_status,
      }),
    },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}
